import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import AssembleiaItemDiscuta from '../../../../models/assembleia/assembleiaItemDiscuta.model';
import { AbAssembleiaItemDiscuta } from 'app/abstract/full-pages/assembleia/assembleia-item-discuta.abstract';

@Injectable({ providedIn: 'root' })
export class AssembleiaItemDiscutaService extends AbAssembleiaItemDiscuta {
  prefixo = 'assembleia_item_discuta/';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public salvarAlterarDados(entity: AssembleiaItemDiscuta) {
    return this.save(this.prefixo, entity);
  }

  public getAllItemDiscuta(itemId: number) {
    return this.get(`${(this.prefixo)}dto/${itemId}`);
  }

}
